import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../index.css';
import App from './App';
import { AppProviders } from './providers/AppProviders';
import { initI18n } from '@app/i18n';
import { registerModule } from '@core/router/moduleRegistry';
import { fleetsModule } from '@modules/fleets';
import { usersModule } from '@modules/users';

// Register all modules
const registerModules = () => {
  registerModule(fleetsModule);
  registerModule(usersModule);
  // Add more modules here as they are created
};

const bootstrap = async () => {
  // Register modules
  registerModules();

  // Initialize i18n
  await initI18n();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </StrictMode>
  );
};

void bootstrap();
